import { render, staticRenderFns } from "./priceCollect.vue?vue&type=template&id=97622bac&scoped=true&"
import script from "./priceCollect.vue?vue&type=script&lang=js&"
export * from "./priceCollect.vue?vue&type=script&lang=js&"
import style1 from "./priceCollect.vue?vue&type=style&index=1&id=97622bac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97622bac",
  null
  
)

export default component.exports